export const productsData = [
  {
    id: 1,
    name: "Царь-Вишня",
    description: "Крупные вареники ручной лепки с сочной вишней премиум-сорта. Сочетание измельченной и цельной ягоды для более плотной начинки.",
    price: "от 450 ₽/кг",
    image: "/img/vishn.webp"
  },
  {
    id: 2,
    name: "Царь-Клубника",
    description: "Крупные вареники ручной лепки с измельченными ягодами клубники. Только клубника, сахар и тесто. Все, как дома.",
    price: "от 420 ₽/кг",
    image: "/img/klubnika.webp"
  },
  {
    id: 3,
    name: "Вареники с клубникой",
    description: "Измельченные ягоды ароматной клубники из жаркого Египта. Кукурузный крахмал для лучшей консистенции. Форма розового сердца добавит",
    price: "от 550 ₽/кг",
    image: "/img/lubnika.webp"
  },
  {
    id: 4,
    name: "Вареники с черникой",
    description: "Начинка из дикорастущей черники из Карелии. Натуральный загуститель – кукурузный крахмал для идеальной текстуры. Лёгкая сладость – минимальное добавление сахара.",
    price: "от 450 ₽/кг",
    image: "/img/cherniaka.webp"
  },
  {
    id: 5,
    name: "Вареники с малиной",
    description: "Начинка сочетает в себе нежное малиновое пюре и свежие ягоды, создавая взрывной ягодный вкус с лёгкой кислинкой и натуральной сладостью.",
    price: "от 420 ₽/кг",
    image: "/img/malina.webp"
  },
  {
    id: 6,
    name: "Вареники с манго и творожным сыром",
    description: "Начинка из спелого манго сорта Атаульфо с медовой мякотью из солнечного Египта и сливочным сыром Крем-Чиз.",
    price: "от 420 ₽/кг",
    image: "/img/mango.webp"
  },
  {
    id: 7,
    name: "Ленивые вареники",
    description: "На основе творога племенного хозяйства Тульской области, рисовой и пшеничной муки с добавлением кукурузного крахмала для упругости.",
    price: "от 450 ₽/кг",
    image: "/img/len.webp"
  },
  {
    id: 8,
    name: "Вареники с сыром Сулугуни творогом и зеленью",
    description: "Грузинские нотки в славянской классике. Уникальное сочетание Сулугуни и нежности творога.",
    price: "от 420 ₽/кг",
    image: "/img/sulug.webp"
  },
  {
    id: 9,
    name: "Котлеты Пожарские",
    description: "Это сочные, нежные рубленые котлеты из птицы (традиционно из курицы или телятины), обвалянные в хрустящих панировочных сухарях и обжаренные до золотистой корочки.",
    price: "от 420 ₽/кг",
    image: "/img/pozar.webp"
  },
  {
    id: 10,
    name: "Котлеты с сырной корочкой",
    description: "Аппетитные котлеты, покрытые золотистой сырной корочкой, – это гарантия сочности и насыщенного вкуса.",
    price: "от 420 ₽/кг",
    image: "/img/cheeze.webp"
  },
  {
    id: 11,
    name: "Голубцы",
    description: "Традиционное блюдо с начинкой из мяса и риса в капустных листьях.",
    price: "от 420 ₽/кг",
    image: "/img/golub.webp"
  }
];